import * as React from 'react';

/**
 * deferComponentRender HOC
 *
 * This HOC serves to defer the rendering of large trees of components, such as you find in the Subject View,
 * until all other UI updates are complete.  This improves perceived importance by moving all other UI behavior
 * to the front of the line, and saving expensive renders for later.
 *s
 * See "Defer Rendering When Mounting & Unmounting Many Components"
 * https://medium.com/@paularmstrong/twitter-lite-and-high-performance-react-progressive-web-apps-at-scale-d28a00e780a3
 */
interface State {
  shouldRender: boolean;
}

export default function deferComponentRender(
  WrappedComponent: React.ComponentType<any>
): React.ComponentType<any> {
  return class DeferredRenderWrapper extends React.Component<any, State> {
    state = {
      shouldRender: false
    };

    componentDidMount() {
      global.requestAnimationFrame(() => {
        global.requestAnimationFrame(() => this.setState({shouldRender: true}));
      });
    }

    render(): React.ReactNode {
      return !this.state.shouldRender ? null : <WrappedComponent {...this.props} />;
    }
  };
}
